<h2 class="mat-h2">Accounts</h2>

<!-- {{ log(selectedCountries )}}
{{ log(selectedRegions )}} -->

<!--
<mat-paginator #paginator *ngIf="accountsPaginationParams"
  (page)="accountsPageChangeEvent($event)"
  [length]="accountsPaginationParams.length"
  [pageSize]="accountsPaginationParams.pageSize"
  [pageIndex]="accountsPaginationParams.pageIndex"
  [pageSizeOptions]="accountsPaginationParams.pageSizeOptions"
  aria-label="Select page">
</mat-paginator>
-->

<mat-paginator #paginator *ngIf="accountsPaginationParams"
  [pageIndex]="accountsPaginationParams.pageIndex"
  [length]="accountsPaginationParams.length"
  [pageSize]="accountsPaginationParams.pageSize"
  [pageSizeOptions]="accountsPaginationParams.pageSizeOptions"
  aria-label="Select page">
</mat-paginator>

<table *ngIf="accountsDataSource" mat-table [dataSource]="accountsDataSource" class="resize firstCol20 table-fixed" matSort>
  <ng-container matColumnDef="account">
    <th mat-header-cell *matHeaderCellDef>Accounts</th>
    <td mat-cell *matCellDef="let element" class="truncated">{{ element.account }}</td>
  </ng-container>
  <ng-container matColumnDef="patientPotentialKam">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{ getHeader('c_proj_patient_potential1') }}">{{ getHeader('c_proj_patient_potential1') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.patientPotentialKam }}</td>
  </ng-container>
  <ng-container matColumnDef="patientPotentialIqvia">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{ getHeader('c_proj_patient_potential2') }}">{{ getHeader('c_proj_patient_potential2') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.patientPotentialIqvia }}</td>
  </ng-container>
  <ng-container matColumnDef="percentOfPatientsPotentialKam">
    <th mat-header-cell *matHeaderCellDef>%<span>Of {{ getHeader('c_proj_patient_potential1') }}</span></th>
    <td mat-cell *matCellDef="let element">{{ element.percentOfPatientsPotentialKam }}</td>
  </ng-container>
  <ng-container matColumnDef="patientUtilisationKam">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{ getHeader('patient_utilisation1') }}">{{ getHeader('patient_utilisation1') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.patientUtilisationKam }}</td>
  </ng-container>
  <ng-container matColumnDef="percentOfPatientPotentialKam">
    <th mat-header-cell *matHeaderCellDef>%<span>Of {{ getHeader('patient_utilisation1') }}</span></th>
    <td mat-cell *matCellDef="let element">{{ element.percentOfPatientPotentialKam }}</td>
  </ng-container>
  <ng-container matColumnDef="utilisation">
    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by {{ getHeader('sales_patient_equivalents') }}">{{ getHeader('sales_patient_equivalents') }}</th>
    <td mat-cell *matCellDef="let element">{{ element.utilisation }}</td>
  </ng-container>
  <ng-container matColumnDef="percentOfPatientUtilisationKam">
    <th mat-header-cell *matHeaderCellDef>% <span>Of {{ getHeader('sales_patient_equivalents') }}</span></th>
    <td mat-cell *matCellDef="let element">{{ element.percentOfPatientUtilisationKam }}</td>
  </ng-container>
  <tr mat-header-row *matHeaderRowDef="accountsDisplayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: accountsDisplayedColumns;"></tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell center" [attr.colspan]="accountsDisplayedColumns.length">No data available</td>
  </tr>
</table>
